import { ContentItem } from "@api";

export const enum IlluminatedImageMode
{
    Off,
    On,
}

export interface IlluminatedImageDiagram
{
    count?: number;
    initialDelay?: number;
    inverse?: boolean;
    offDuration?: number;
    onDuration?: number;
}

export interface IlluminatedImageHandle
{
    execute: (diagram?: IlluminatedImageDiagram) => void;
    off: () => void;
    on: () => void;
}

export interface IlluminationMode
{
    description: ContentItem;
    diagram?: IlluminatedImageDiagram;
    title: ContentItem;
}
